<template>

  <div class="bg-violet-500 p-8">
    <div class="w-full md:container mx-auto px-4">
      <div class="flex flex-col text-center lg:text-left lg:flex-row lg:space-x-4 items-center">
        <div class="flex-1 mb-4">
          <h3 class="text-white text-lg font-bold">Subscreva a newsletter</h3>
          <p class="text-white">Receba as nossas novidades na sua caixa de correio eletrónico</p>
        </div>
        <div class="flex-1 flex-col text-center sm:text-left flex sm:flex-row sm:space-x-2 items-center relative">
          <jet-input-error :message="form.errors.email" class="absolute top-7 left-4" />
          <jet-input type="text" v-model="form.email" placeholder="Email" class="w-full md:flex-1 rounded-lg text-lg" />
          <jet-button @click="subscribe" class="focus:ring-0 w-full md:flex-1 text-lg text-center justify-center mt-4 sm:mt-0">Subscrever</jet-button>
        </div>
      </div>

      <input type="hidden" v-model="pfield">

      <div class="mt-4 text-center lg:text-right">
        <jet-checkbox v-model="form.rgpd" class="mr-2 text-sm"></jet-checkbox> Li e aceito a <br class="md:hidden"> <a :href="route('pol_privacidade')" class="text-white underline text-sm">Política de Privacidade</a>
          <jet-input-error :message="form.errors.rgpd" />
      </div>

    </div>
  </div>
  
</template>

<script>
  import { defineComponent } from 'vue'
  import { Head, Link } from '@inertiajs/inertia-vue3';
  import JetButton from '@/Jetstream/Button.vue'
  import JetInput from '@/Jetstream/Input.vue'
  import JetInputError from '@/Jetstream/InputError.vue'
  import JetCheckbox from '@/Jetstream/Checkbox.vue'

  export default defineComponent({
    components: {
      JetButton,
      JetInput,
      JetInputError,
      JetCheckbox
    },
    data() {
      return {
        pfield: '',
        form: this.$inertia.form({
          email: '',
          rgpd: false
        })
      }
    },
    methods: {
      subscribe() {
        if(this.pfield == '') {
          this.form.post(route('subscribe'), {
            preserveScroll: true,
            onSuccess: () => this.form.reset(),
            onError: () => {}
          })
        }
      },
    }

  })
</script>
 